import React from 'react';

import style from './index.module.scss';

const TruInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Единичные расценки ТРУ Интернет-магазина:</h1>

    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис включает в себя:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          С помощью набора фильтров и ключевых слов сервис подберет реально проведенные сделки в Интернет-магазине
          ТЭК-Торг и покажет единичную стоимость закупаемой номенклатуры
        </div>
      </div>
    </div>
  </>
);

export default TruInfo;
